<template>
  <div v-if="componentReady" class="container-wrapper_sm">
    <section class="container policy-page">
      <BaseButton
        type="secondary"
        class="policy-page__button"
        @click.native="$router.go(-1)"
      >
        {{ backLinkText }}
      </BaseButton>
      <h1 class="policy-page__title">{{ title }}</h1>
      <div class="policy-page__content" v-html="content" />
    </section>
  </div>
</template>

  <script>
  import { mapActions } from 'vuex'

  export default {
    name: 'MarketingPage',

    data () {
      return {
        title: '',
        backLinkText: '',
        content: '',
        componentReady: false
      }
    },

    async created () {
      const { title, backLinkText, content } = await this.fetchMarketingPageData()
      this.title = title
      this.backLinkText = backLinkText
      this.content = content

      this.componentReady = true
    },

    methods: {
      ...mapActions(['fetchMarketingPageData'])
    }
  }
  </script>

  <style lang="scss">
    .policy-page {
      &__button {
        min-width: 81px;
        margin-bottom: 80px;

        @include mobile {
          margin-bottom: 40px;
        }
      }

      &__title {
        margin: 0 auto 60px;

        @include mobile {
          margin-bottom: 40px;
        }
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        color: $c-black;
        text-align: left;
      }

      h1 {
        font-family: "FavoritC", Arial, Helvetica, sans-serif;
        font-size: 40px;
        font-weight: 400;
        line-height: 1.4;
        text-transform: uppercase;
        letter-spacing: 0.08px;

        @include mobile {
          font-size: 28px;
          line-height: 1.42;
        }
      }

      h2 {
        font-family: "FavoritC", Arial, Helvetica, sans-serif;
        font-size: 40px;
        font-weight: 400;
        line-height: 63px;
        text-transform: uppercase;
        letter-spacing: 0.08px;

        @include mobile {
          font-size: 24px;
          line-height: 34px;
        }
      }

      h3 {
        font-family: "FavoritC", Arial, Helvetica, sans-serif;
        font-size: 36px;
        font-weight: 400;
        line-height: 50px;
        text-transform: uppercase;

        @include mobile {
          font-size: 18px;
          line-height: 26px;
        }
      }

      h4 {
        padding: 30px 0;
        font-family: "FavoritC", Arial, Helvetica, sans-serif;
        font-size: 25px;
        font-weight: 400;
        line-height: 1.4;
        text-transform: uppercase;
        letter-spacing: 0.08px;
        border-top: 2px solid $c-black;
        border-bottom: 2px solid $c-black;

        @include mobile {
          padding: 15px 0;
          font-size: 24px;
          line-height: 34px;
        }
      }

      h5,
      h6 {
        font-family: "FavoritC", Arial, Helvetica, sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.35;
      }

      p,
      .p {
        font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
        font-size: 17px;
        font-weight: 400;
        line-height: 24px;

        @include mobile {
          font-size: 15px;
          line-height: 21px;
        }
      }

      strong {
        font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
        font-weight: 700;
      }

      table {
        height: auto !important;
        background-color: $c-white;

        @include mobile {
          display: block;
        }

        tbody {
          @include mobile {
            display: block;
            overflow-x: auto;
          }
        }

        tr {
          &:first-child {
            td {
              padding: 30px 20px;
            }
          }

          &:last-child {
            td {
              border-bottom: none;
            }
          }

          &:nth-child(odd) {
            background-color: $c-table-background;
          }
        }

        td {
          padding: 20px;
          font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
          font-size: 14px;
          line-height: 20px;
          color: $c-black;
          border: 1px solid $c-gray-medium;

          &:first-child {
            border-left: none;
          }

          &:last-child {
            border-right: none;
          }
        }
      }

      ul,
      ol {
        li {
          font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
          font-size: 17px;
          font-weight: 400;
          line-height: 24px;

          @include mobile {
            font-size: 15px;
            line-height: 21px;
          }
        }
      }
    }
  </style>
